import Link from "next/link";
import { content } from "../../data/siteData";
import { getCaseStudy } from "../../data/projects";
import { localePath } from "../../lib/seo";

const ExperienceTimeline = ({ locale }) => {
  const t = content[locale].experience;

  return (
    <section
      id="experience"
      className="w-full py-16 md:py-24 px-6 md:px-12 bg-[#f5f5f5]"
    >
      <div className="max-w-7xl mx-auto flex flex-col gap-10 md:gap-16">
        <h2 className="font-poppins font-extralight text-4xl md:text-5xl lg:text-[64px] text-[#333333] text-left leading-none">
          {t.heading}
        </h2>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-[2px] bg-gray-300 -translate-x-1/2"></div>

          <div className="flex flex-col gap-8 md:gap-32">
            {t.items.map((item, index) => (
              <div
                key={item.title}
                className={`relative flex flex-col md:flex-row ${index % 2 === 0 ? "md:justify-start" : "md:justify-end"}`}
              >
                <div className="hidden md:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-[#333333] rounded-full z-10"></div>

                <div
                  className={`w-full md:w-[45%] bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden group ${index % 2 === 0 ? "md:mr-auto" : "md:ml-auto"}`}
                >
                  <div className="p-6 md:p-8">
                    <div className="flex items-start md:items-center justify-between mb-2 gap-4">
                      <h3 className="font-poppins font-light text-xl md:text-2xl text-[#333333]">
                        {item.title}
                      </h3>
                    </div>
                    <p className="font-poppins font-light text-sm md:text-base text-[#666666] mb-4">
                      {item.period}
                    </p>
                    <p className="font-poppins font-light text-sm md:text-base text-[#555555] mb-4">
                      {item.description}
                    </p>

                    {item.tech.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-4">
                        {item.tech.map((techItem) => (
                          <span
                            key={techItem}
                            className="px-2.5 md:px-3 py-1 text-xs md:text-sm font-poppins font-light bg-[#f5f5f5] text-[#333333] rounded-full"
                          >
                            {techItem}
                          </span>
                        ))}
                      </div>
                    )}

                    {item.slug && (
                      <Link
                        href={localePath(locale, `/projects/${item.slug}`)}
                        aria-label={`${t.caseStudy}: ${getCaseStudy(item.slug)[locale].title}`}
                        className="inline-block mt-6 font-poppins font-normal text-sm md:text-base text-[#333333] underline underline-offset-4 hover:text-[#555555]"
                      >
                        {t.caseStudy} &rarr;
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceTimeline;
